import { ChainType } from "@0xsquid/squid-types";
import { UseMutationResult } from "@tanstack/react-query";
import React, { createContext, useContext } from "react";
import { useStellar } from "../../hooks/stellar/useStellar";
import { StellarConnector } from "../types/stellar";
import { ConnectWalletResult, StellarWallet } from "../types/wallet";

export interface IStellarContextData {
  connectStellar: UseMutationResult<
    ConnectWalletResult<ChainType.STELLAR>,
    unknown,
    {
      wallet: StellarWallet;
    },
    unknown
  >;
  disconnectStellar: () => Promise<void>;
  signer: StellarConnector | undefined;
  wallets: StellarWallet[];
}

export const StellarContext = createContext<IStellarContextData | undefined>(
  undefined
);

export const StellarProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const stellarContext = useStellar();

  return (
    <StellarContext.Provider value={stellarContext}>
      {children}
    </StellarContext.Provider>
  );
};

export const useStellarContext = (): IStellarContextData => {
  const context = useContext(StellarContext);
  if (!context) {
    throw new Error("useStellarContext must be used within a StellarProvider");
  }
  return context;
};
